import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import Popup from '../../components/Layout/popup';

// Import images
import homeShape from '../../assets/images/saas/home-shape.png';
//import saas1 from "../../assets/images/saas/classic02.png";
import widget from '../../assets/images/itoagent/widget_h650.png';

const Widget = () => {
  return (
    <React.Fragment>
      <section
        className="bg-home d-flex align-items-center"
        style={{
          background: `url(${homeShape})`,
          backgroundPosition: 'center center',
          height: 'auto',
        }}
        id="home"
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} className="text-center mt-0 mt-md-5 pt-0 pt-md-5">
              <div className="title-heading margin-top-100">
                <h1 className="heading mb-3">
                  Engage Customers Instantly with Itoagent LiveChat..
                </h1>
                <p className="para-desc mx-auto text-muted">
                  Deliver real-time support and timely follow-ups. Centralise
                  conversations and customer profiles to build a robust
                  database. Empower your team to understand client needs and
                  resolve issues, build lasting trust and reputation.
                </p>
                <div className="mt-4 pt-2">
                  <Link to="/register" className="btn btn-primary">
                    Start your free trial{' '}
                    <i className="uil uil-angle-right-b"></i>
                  </Link>
                  <div>No credit card is required. Cancel any time.</div>
                </div>
              </div>

              <div className="home-dashboard">
                <Container className="mt-0 mt-0">
                  <Row className="align-items-center">
                    <Col lg={6} md={6}>
                      <img
                        style={{ height: '500px' }}
                        src={widget}
                        className="img-fluid shadow rounded"
                        alt=""
                      />
                    </Col>

                    <Col lg={6} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                      <div className="section-title ms-lg-5">
                        <h4 className="title mb-4">
                          Simple, lightweight yet powerful.
                        </h4>
                        <p className="text-muted">
                          Written in plain JS, It is easy to install and
                          integrate, offering faster loading times that make a
                          great first impression.
                        </p>
                        <ul className="list-unstyled text-muted">
                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                            Seamless Design
                          </li>

                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                            Native look and feel
                          </li>

                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                            Intelligent
                          </li>

                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                            Enhanced Reliability and Performance
                          </li>
                        </ul>
                        {/**
              <Link to="#" className="mt-3 h6 text-primary">Find Out More <i className="uil uil-angle-right-b"></i></Link>
              **/}
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Popup />
    </React.Fragment>
  );
};

export default Widget;
